module.exports = __webpack_public_path__ + "static/img/Frame18.fa6cbcb2.png";